import { render } from "./OrganizationSettingRight.vue?vue&type=template&id=0e7ba698"
import script from "./OrganizationSettingRight.vue?vue&type=script&lang=js"
export * from "./OrganizationSettingRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__